import gsap from "@lib/gsap";

export interface LineDrawOptions {
  duration?: number;
  end?: number;
  ease?: string;
  delay?: number;
}

const DEFAULTS: Required<LineDrawOptions> = {
  duration: 3.2,
  end: 0.03,
  ease: "power3.out",
  delay: 0,
};

const PATH_SELECTOR = "[data-line-path]";

/**
 * Find and prepare an SVG path for stroke-dashoffset animation.
 * Returns null if no path is found in the element.
 */
export function prepLineDraw(element: HTMLElement) {
  const path = element.querySelector<SVGPathElement>(PATH_SELECTOR);
  if (!path) return null;

  const len = path.getTotalLength();
  gsap.set(path, { strokeDasharray: len, strokeDashoffset: len });

  return { path, len };
}

/**
 * Animate the prepared path from fully hidden to nearly complete.
 * Returns the tween so callers can kill it on cleanup.
 */
export function playLineDraw(
  prepared: { path: SVGPathElement; len: number },
  opts: LineDrawOptions = {}
) {
  const { duration, end, ease, delay } = { ...DEFAULTS, ...opts };

  return gsap.fromTo(
    prepared.path,
    { strokeDashoffset: prepared.len },
    {
      strokeDashoffset: prepared.len * end,
      duration,
      ease,
      delay,
    }
  );
}

/**
 * Kill tweens and clear inline dash styles on the path.
 */
export function cleanLineDraw(path: SVGPathElement) {
  gsap.killTweensOf(path);
  gsap.set(path, { clearProps: "strokeDasharray,strokeDashoffset" });
}
